module.exports = __webpack_public_path__ + "img/Newspaper.f6d3667f.jpg";